import GradoService from "@/services/GradoService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");
require("datatables.net");
require("datatables.net-bs4");
require("datatables.net-responsive");

export default {
    name: "RepoGradoPage",
    data() {
        let ss2 = new GradoService();
        
        
        return {
            msg: "RepoGradoPage",

            ruta: process.env.VUE_APP_MAIN_SERVICE_REPOSITORIO_GRADO,

            ss2: ss2,

            ajax: {
                "url": ss2.indexDocumento()
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Documento', name: 'd.Documento', title: 'Documento', searchable: true },
                { data: 'Carrera', name: 'd.Carrera', title: 'Carrera', searchable: true },
                { data: 'ResponsableElaboracion', name: 'd.ResponsableElaboracion', title: 'Autor', searchable: true },
                { data: 'UnidadAcademica', name: 'ua.UnidadAcademica', title: 'Unidad Académica' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],

            repo_grados: [],
            repo_grado: {},

            isLoading: false,
            errorBag: {}
        };
    },
    methods: {



        showDocumento(id) {
            this.isLoading = true;
            this.ss2.showDocumento(id).then(
                (result) => {
                    let response = result.data;
                    this.repo_grado = response.data;
                    this.$refs['view-repo_grado'].show();
                    this.isLoading = false;

                    window.$('.btn-datatable-Documento').on('click', (evt) => {
                        let data = window.$(evt.target)[0].id;
                        console.log(data)
                    });
                }
            ).catch(error => {
                console.log(error);
                this.isLoading = false;
            });
        },
        draw() {
            window.$('.btn-datatable-Documento').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showDocumento(data);
            });
        }
    },

    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
            this.$router.push('/Login');
        } else {

            this.persona = persona;

        }
    }
};
